import { type PriceInfo, type PriceInfoDTO, transformPrice } from "../../api/pna/PriceInfo";
import { HAS_END_CUSTOMER } from "../../utils/constants";
import { resolveApiUrl } from "../../utils/url/urlResolver";
import { apiGET } from "./apiCallsService";

const apiUrl = resolveApiUrl("/pna/getLcPrice");

export async function getLinearPriceInfo(
  productCode: string,
  configurationId: string,
  priceReference: string,
): Promise<PriceInfo[]> {
  if (priceReference === "" && HAS_END_CUSTOMER) {
    priceReference = window.SCHA.config.priceReferences[1].value;
  }

  let url = `${apiUrl}/${productCode}/${configurationId}`;
  if (priceReference) {
    url += `?priceReference=${priceReference}`;
  }

  const response = await apiGET(url);
  if (!response.ok) {
    throw new Error("Error fetching data");
  }
  const dto = (await response.json()) as PriceInfoDTO[];
  const res = dto.map(transformPrice);
  res.forEach((x) => (x.priceReference = priceReference));
  return res;
}
